/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

const cache_version = 1552020; // cache version က local storage key နဲ့ချိတ်ထားတာ

export const keys = {
    BRANCH_LIST:                    'branch_list',
    BRANCH_SELECT_LIST:             'branch_select_list',
    BRANCH_COLLECTION_SELECT_LIST:  'branch_collection_select_list',
    TOWNSHIP_LIST:                  'township_list',
    TOWNSHIP_SELECT_LIST:           'township_select_list'
};

export const generate_key = (url, params = {}) => {
    
    let param_keys = Object.keys(params);

    param_keys = $(param_keys).sort().map((key, value) => {
        return `${value}=${params[value]}`;
    });

    return `${url}${cache_version}${$.makeArray(param_keys).join(',')}`;
};  


export default {
    ttl: 1000 * 24 * 60 * 60,
    generate_key,
    keys: keys,
    [keys.BRANCH_LIST]: window.localStorage.getItem(keys.BRANCH_LIST) ? window.localStorage.getItem(keys.BRANCH_LIST) : null,
    [keys.BRANCH_SELECT_LIST] : window.localStorage.getItem(keys.BRANCH_SELECT_LIST) ? window.localStorage.getItem(keys.BRANCH_SELECT_LIST) : null,
    [keys.BRANCH_COLLECTION_SELECT_LIST]: window.localStorage.getItem(keys.BRANCH_COLLECTION_SELECT_LIST) ? window.localStorage.getItem(keys.BRANCH_COLLECTION_SELECT_LIST) : null,
    [keys.TOWNSHIP_SELECT_LIST]: window.localStorage.getItem(keys.TOWNSHIP_SELECT_LIST) ? window.localStorage.getItem(keys.TOWNSHIP_SELECT_LIST) : null,
};
